import type { ButtonType } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { CONFIRM_DEFAULT_ACTIVATION_MODAL_CLOSE_BUTTON, CONFIRM_DEFAULT_ACTIVATION_MODAL_UPDATE_BUTTON } from "./texts";

export const confirmDefaultModalConfig = {
    content: {
        width: "400px",
        padding: 0,
    },
};

export const getCloseButtonConfig = () => ({
    label: translate(CONFIRM_DEFAULT_ACTIVATION_MODAL_CLOSE_BUTTON),
    type: "flat" as ButtonType,
    tooltipEnabled: false,
});

export const getConfirmButtonConfig = () => ({
    label: translate(CONFIRM_DEFAULT_ACTIVATION_MODAL_UPDATE_BUTTON),
    type: "primary" as ButtonType,
    tooltipEnabled: false,
});
